import { findIndex, sortBy } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import RecommendReviewSaveWrap from '../../../views/recommend/review/copy/RecommendReviewSaveWrap';
import { recommendReviewActions } from '../../../store/modules/recommend/review';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../constants/service/common/utilConstants';
import {
  MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT,
  MINIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT,
} from '../../../constants/service/app/recommendReviewConstants';
import { asyncSimpleModal } from '../../../lib/common';

class RecommendReviewSaveContainer extends Component {
  /**
   *  추천 상품 후기 복사하기
   */
  onSubmit = () => {
    const { form, recommendReviewSave, createRecommendReview } = this.props;
    const { recommendReviewInfo, recommendReviewItemList } = recommendReviewSave;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) return;

      /**
       *  추천 상품 후기 아이템 최소 개수 체크
       */
      if (recommendReviewItemList.selectedItemList.list.length < MINIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT) {
        message.error(`추천 상품 후기 아이템은 최소 ${MINIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT}개이상입니다.`);
        return;
      }

      createRecommendReview({
        /**
         *  추천 상품 후기 정보
         */
        recommendReviewInfo: {
          /**
           *  추천 상품 후기 타입
           */
          type: recommendReviewInfo.type,
          /**
           *  메모
           */
          memo: recommendReviewInfo.memo,
        },
        /**
         *  추천 상품 후기에 연결된 상품 후기 id 리스트
         */
        recommendReviewItemIdList: recommendReviewItemList.selectedItemList.idList,
      });
    });
  };

  /**
   *  추천 상품 후기에 연결할 아이템 리스트 불러오기
   */
  getRecommendReviewItemList = (option) => {
    const { getRecommendReviewItemList, recommendReviewSave } = this.props;
    const { recommendReviewItemList } = recommendReviewSave;
    const { filterOption, sortOption, pagination } = recommendReviewItemList.itemList;

    getRecommendReviewItemList({
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  추천 상품 후기에 연결할 아이템 선택하기
   */
  selectRecommendReviewItemList = async (action, moveIdList) => {
    const { setData, recommendReviewSave } = this.props;
    const { recommendReviewItemList } = recommendReviewSave;
    const { itemList, selectedItemList } = recommendReviewItemList;

    /**
     *  업데이트 될 선택된 연결할 아이템 리스트
     */
    let updatedSelectRecommendReviewItemList = [];

    /**
     *  연결할 아이템 아이템 추가
     */
    if (action === 'add') {
      let targetList = itemList.list.filter((item) => moveIdList.includes(item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 아이템을 합침
       */
      updatedSelectRecommendReviewItemList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 아이템 개수가 초과되었을 경우
       */
      if (updatedSelectRecommendReviewItemList.length > MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT) {
        await asyncSimpleModal({
          type: 'error',
          title: '아이템 개수 초과',
          message: `추천 상품 후기 아이템 개수는 최대 ${MAXIMUM_NUMBER_OF_RECOMMEND_REVIEW_ITEM_COUNT} 입니다.`,
        });
        return;
      }
    } else if (action === 'remove') {
      /**
       *  연결할 아이템 아이템 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      updatedSelectRecommendReviewItemList = selectedItemList.list.filter((item) => !moveIdList.includes(item.id));
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedRecommendReviewItemList = itemList.list.map((item) => ({
      ...item,
      uncheckable: moveIdList.includes(item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['recommendReviewSave', 'recommendReviewItemList', 'itemList', 'list'],
      value: updatedRecommendReviewItemList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['recommendReviewSave', 'recommendReviewItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendReviewItemList,
        idList: updatedSelectRecommendReviewItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  추천 상품 후기 리스트 아이템 순서 변경하기
   */
  onDragEndSelectRecommendReviewItemList = async (newList) => {
    const { setData, recommendReviewSave } = this.props;
    const { recommendReviewItemList } = recommendReviewSave;
    const { selectedItemList } = recommendReviewItemList;

    const updatedSelectRecommendReviewItemList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['recommendReviewSave', 'recommendReviewItemList', 'selectedItemList'],
      value: {
        list: updatedSelectRecommendReviewItemList,
        idList: updatedSelectRecommendReviewItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  전체 상품 후기 리스트 EXCEL 다운로드
   */
  getRecommendReviewItemListExcelDownload = () => {
    const { getRecommendReviewItemListExcelDownload, recommendReviewSave, adminInfo } = this.props;
    const { recommendReviewItemList } = recommendReviewSave;
    const { filterOption, sortOption } = recommendReviewItemList.itemList;

    getRecommendReviewItemListExcelDownload({
      email: adminInfo.email,
      filterOption,
      sortOption,
    });
  };

  /**
   *  선택된 상품 후기 리스트 EXCEL 다운로드
   */
  getSelectedRecommendReviewItemListExcelDownload = () => {
    const { getSelectedRecommendReviewItemListExcelDownload, recommendReviewSave, adminInfo } = this.props;
    const { recommendReviewItemList } = recommendReviewSave;
    const { idList } = recommendReviewItemList.selectedItemList;

    if (!idList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getSelectedRecommendReviewItemListExcelDownload({
      email: adminInfo.email,
      selectedRecommendReviewItemIdList: idList,
    });
  };

  /**
   *  상품 후기 리스트 EXCEL 업로드
   */
  setRecommendReviewItemListExcelUpload = (file) => {
    const { setRecommendReviewItemListExcelUpload } = this.props;

    setRecommendReviewItemListExcelUpload({
      attachment: [file],
    });
  };

  render() {
    const { form, recommendReviewSave, setData, typeDisabled } = this.props;

    return (
      <RecommendReviewSaveWrap
        form={form}
        setData={setData}
        recommendReviewSave={recommendReviewSave}
        typeDisabled={typeDisabled}
        getRecommendReviewItemList={this.getRecommendReviewItemList}
        selectRecommendReviewItemList={this.selectRecommendReviewItemList}
        onSubmit={this.onSubmit}
        onDragEndSelectRecommendReviewItemList={this.onDragEndSelectRecommendReviewItemList}
        getRecommendReviewItemListExcelDownload={this.getRecommendReviewItemListExcelDownload}
        getSelectedRecommendReviewItemListExcelDownload={this.getSelectedRecommendReviewItemListExcelDownload}
        setRecommendReviewItemListExcelUpload={this.setRecommendReviewItemListExcelUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    recommendReviewSave: state.recommendReview.recommendReviewSave,
  };
};

const mapDispatchToProps = {
  setData: recommendReviewActions.setData,
  getRecommendReviewItemList: recommendReviewActions.getRecommendReviewItemList,
  createRecommendReview: recommendReviewActions.createRecommendReview,
  getRecommendReviewItemListExcelDownload: recommendReviewActions.getRecommendReviewItemListExcelDownload,
  getSelectedRecommendReviewItemListExcelDownload:
    recommendReviewActions.getSelectedRecommendReviewItemListExcelDownload,
  setRecommendReviewItemListExcelUpload: recommendReviewActions.setRecommendReviewItemListExcelUpload,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(RecommendReviewSaveContainer));
